import MuiButton, { ButtonProps as MuiButtonProps } from '@mui/material/Button';

export interface ButtonProps extends Omit<MuiButtonProps, 'variant' | 'color'> {
  /** primary = black filled pill (Figma CTAs), secondary = light-grey filled pill with
   * blue text (Figma onboarding "Select All"/"Back", nodes 3339:44965 / 3339:45411),
   * text = link-style */
  variant?: 'primary' | 'secondary' | 'text';
}

const variantMap = {
  primary: { variant: 'contained', color: 'primary' },
  // CC's own UiButton maps `secondary` the same way, onto its `containedSecondary`
  // style (adminPanelTheme.ts:561-578: #F7F7F7 background, #01ADEF text) — NOT
  // `outlined`, which renders low-contrast grey-on-grey and doesn't match Figma.
  secondary: { variant: 'contained', color: 'secondary' },
  text: { variant: 'text', color: 'primary' },
} as const;

export function Button({ variant = 'primary', sx, ...rest }: ButtonProps) {
  const mapped = variantMap[variant];
  return (
    <MuiButton
      variant={mapped.variant}
      color={mapped.color}
      sx={{
        // Height/padding/radius come entirely from the theme's MuiButton root
        // and contained/containedSecondary overrides (adminPanelTheme.ts:495-578)
        // now — no hand-rolled geometry here to fight them. `text` still needs
        // its own sizing: the theme has no "auto height, compact padding"
        // link-style variant, so that part remains kit-owned.
        ...(variant === 'text' && { height: 'auto', px: 1 }),
        ...sx,
      }}
      {...rest}
    />
  );
}
